var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67058 21.094C4.93258 21.355 5.27958 21.5 5.64958 21.5C5.88658 21.5 6.12058 21.438 6.32758 21.323L12.0246 18.129L17.6666 21.316C17.9886 21.499 18.3616 21.543 18.7186 21.444C19.0746 21.346 19.3706 21.113 19.5526 20.791C19.6696 20.583 19.7316 20.349 19.7316 20.112L19.7266 6.586C19.7266 3.951 18.0326 2.5 14.9566 2.5H9.03958C6.00658 2.5 4.26758 3.927 4.26758 6.415V20.116C4.26658 20.485 4.40958 20.832 4.67058 21.094ZM13.2736 12.8496H10.7256C10.3116 12.8496 9.97558 12.5136 9.97558 12.0996C9.97558 11.6856 10.3116 11.3496 10.7256 11.3496H13.2736C13.6876 11.3496 14.0236 11.6856 14.0236 12.0996C14.0236 12.5136 13.6876 12.8496 13.2736 12.8496ZM9.37359 8.90625H14.6256C15.0396 8.90625 15.3756 8.57025 15.3756 8.15625C15.3756 7.74225 15.0396 7.40625 14.6256 7.40625H9.37359C8.95959 7.40625 8.62359 7.74225 8.62359 8.15625C8.62359 8.57025 8.95959 8.90625 9.37359 8.90625Z",
    fill: "#791469"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark1);
export default __webpack_public_path__ + "static/media/Bookmark_1.7ac1c28ac76c5471a659cbbbfda661a6.svg";
export { ForwardRef as ReactComponent };